import { useEffect } from 'react';

import * as Analytics from 'services/analytics';
import * as ErrorLogging from 'services/ErrorLogging';

/**
 * For running one-off analytics events (usually a "page viewed" event)
 * Example:
   const ModalComponent = ({ visible }) => {
    useAnalyticsEffect(
      ({ events, logEvent }) => {
        if (visible) logEvent(events.modalViewed),
        [visible]
      }
    )
 }
 * @param {function} analyticsCallback
 * @param {array} dependencies - React hook dependencies,
 *   defaults to [] because analytics events should definitely not happen on every render
 * @returns {undefined}
 */
const useAnalyticsEffect = (analyticsCallback, dependencies = []) => {
  useEffect(() => {
    // Analytics errors should not break the app, so rescue all errors here
    try {
      return analyticsCallback({ events: Analytics.events, logEvent: Analytics.logEvent });
    } catch (e) {
      ErrorLogging.captureException(e.message);
    }
  }, dependencies);
};

export default useAnalyticsEffect;
